import { cx } from '@linaria/core';
import { centerCls } from '@pm2/react-utils';
import { useAppContext } from '@provider/app-context';
import { PublisherLogo } from '@ui/kit/icons';
import { wrapper, svg, publisherLogo, publisherLogoWrapper } from './atom.basic-footer.style.js';
import { ReliefSVG } from './atom.relief-svg.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function BasicFooter() {
  const publisher = useAppContext(state => state.publisher);
  return /*#__PURE__*/jsxs("footer", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(ReliefSVG, {
      position: "bottom",
      className: svg
    }), publisher !== "louisiana" && /*#__PURE__*/jsx("div", {
      className: cx(centerCls, publisherLogoWrapper),
      children: /*#__PURE__*/jsx("div", {
        className: publisherLogo,
        children: /*#__PURE__*/jsx(PublisherLogo, {
          small: true
        })
      })
    })]
  });
}

export { BasicFooter };
//# sourceMappingURL=atom.basic-footer.js.map
